"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("title", null, "Trace Icons_1-3"), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M26.93,3.38a1.56,1.56,0,0,0-1.36-.85H6.43a1.56,1.56,0,0,0-1.36.85A1.78,1.78,0,0,0,5.08,5l7.54,12.76v12l6.76-2.71V17.79L26.94,5A1.76,1.76,0,0,0,26.93,3.38Z"
})));
module.exports = exports.default;